module.exports = __webpack_public_path__ + "static/media/IMG_2187.3d95babd.jpg";